import { Client, ClientContactDTO } from 'model';
import { createErrorHandlingThunk } from '../../../../redux/thunk';
import { apiClient } from '../../../../api/apiClient';

export const createClientContactThunk = createErrorHandlingThunk<
  Client,
  { clientId: string; dto: ClientContactDTO }
>('client/contacts/create', async (args) => {
  await apiClient.post<Client>(`/client/${args.clientId}/contacts`, args.dto);

  const clientResult = await apiClient.get<Client>(`/client/${args.clientId}`);
  return clientResult.data;
});
